const permissions = {
  home: {
    menu: 'HOME_M',
    attachDashboard: 'ATTACH_DASHBOARD',
    detachDashboard: 'DETACH_DASHBOARD',
    applyFilter: 'DASHBOARD_FILTER_MODIFY',
    clearFilter: 'DASHBOARD_FILTER_CLEAR',
  },
  support: {
    menu: 'SUPPORT_M',
    viewAllTickets: 'SUPPORT_VIEW_ALL_TICKETS',
  },
  project: {
    menu: 'PROJECT_M',
    viewProject: 'VIEW_PROJECT',
    editProject: 'EDIT_PROJECT',
    addProject: 'ADD_PROJECT',
    ctaViewProject: 'CTA_VIEW_PROJECT',
  },
  projectFields: {
    viewProjectFields: 'ADD_PROJECT_FIELDS_VIEW',
    addCategory: 'ADD_CATEGORY',
    addType: 'ADD_PROJECT_TYPE',
    editType: 'MODIFY_PROJECT_TYPE',
    deleteType: 'DELETE_PROJECT_TYPE',
    addStatus: 'ADD_PROJECT_STATUS',
    editStatus: 'MODIFY_PROJECT_STATUS',
    deleteStatus: 'DELETE_PROJECT_STATUS',
    addProjectCategory: 'PROJECT_CATEGORY_ADD',
    editCategory: 'PROJECT_CATEGORY_MODIFY',
    deleteCategory: 'PROJECT_CATEGORY_DELETE',
    paidDate: 'EDIT_PAID_DATE',
  },
  scheduling: {
    menu: 'SCHEDULING_M',
    reportOnHold: 'SCHEDULING_ON_HOLD',
    reportRTS: 'SCHEDULING_RTS',
    reportSchToday: 'SCHEDULING_SCH_TODAY',
    reportWFP: 'SCHEDULING_WFP',
    reportUTC: 'SCHEDULING_UTC',
    reportSchTomorrow: 'SCHEDULING_SCH_TOMORROW',
    modifyScheduleDates: 'MODIFY_SCHEDULE_DATES',
    overrideZipCodeGuardrails: 'OVERRIDE_ZIP_CODE_GUARDRAILS',
    overrideCategorySkillGuardrails: 'OVERRIDE_CATEGORY_SKILL_GUARDRAILS',
  },
  clients: {
    menu: 'CLIENTS_M',
    addClient: 'ADD_CLIENT',
    editClient: 'EDIT_CLIENT',
  },
  items: {
    menu: 'ITEMS_M',
    addLaborItem: 'ADD_LABOR_ITEM',
    editLaborItem: 'EDIT_LABOR_ITEM',
    addMerchandiseItem: 'ADD_MERCHANDISE_ITEM',
    editMerchandiseItem: 'EDIT_MERCHANDISE_ITEM',
    viewCostField: 'VIEW_COST_FIELD',
  },
  viewEditProject: {
    actionOnWay: 'PROJECT_ON_WAY',
    actionLeftMessage: 'PROJECT_LEFT_MESSAGE',
    actionSendReminderText: 'SEND_REMINDER_TEXT',
    actionOnHold: 'PROJECT_ON_HOLD',
    actionCompleted: 'PROJECT_COMPLETED',
    actionClosedJob: 'CLOSE_JOB_VIEW',
    actionNeedReview: 'PROJECT_NEED_REVIEW',
    actionCancelled: 'PROJECT_CANCELLED',
    actionRequalify: 'PROJECT_REQUALIFY',
    actionScheduler: 'SCHEDULER_M',
    actionEditScheduler: 'EDIT_SCHEDULER_M',
    actionContractPending: 'PROJECT_CONTRACT_PENDING',
    actionContractReviewed: 'PROJECT_CONTRACT_REVIEW',
    actionReadyToSchedule: 'READY_TO_SCHEDULE_VIEW',
    actionButtonScheduler: 'SCHEDULER_VIEW',
    actionBustedJob: 'BUSTED_JOB_VIEW',
    actionDeclineLead: 'DECLINE_LEAD_VIEW',
    actionDeclineJob: 'DECLINE_JOB',
    actionAcceptJob: 'ACCEPT_JOB',
    actionRepairOrder: 'REPAIR_ORDER',
    actionSendToFloorsoft: 'SEND_TO_FLOORSOFT_VIEW',
    actionNoCharge: 'DELIVERY_COMPLETE_VIEW',
    actionPullLineItems: 'PULL_LINE_ITEM',
    actionCopyProject: 'COPY_PROJECT',
    actionOnHoldPendingCancel: 'ON_HOLD_PENDING_CANCEL',

    actionCarpetStagedView: 'CARPET_STAGED_VIEW',
    actionPadStagedView: 'PAD_STAGED_VIEW',
    actionFollowUpAmCallView: 'FOLLOW_UP_AM_CALL_VIEW',
    actionFollowUpPmCallView: 'FOLLOW_UP_PM_CALL_VIEW',
    actionWelcomeLeftMessageView: 'WELCOME_LEFT_MESSAGE_VIEW',
    actionWelocomeCallLCompleteView: 'WELCOME_CALL_COMPLETE_VIEW',
    actionDispatchedView: 'DISPATCHED_VIEW',
    actionEtaConfirmedView: 'ETA_CONFIRMED_VIEW',
    actionsInProgressView: 'IN_PROGRESS_VIEW',
    actionsConfirmCompleteView: 'CONFIRM_COMPLETE_VIEW',
    actionQaCompleteView: 'QA_COMPLETE_VIEW',
    actionReundReviewedView: 'REFUND_REVIEWED_VIEW',
    actionSurveyResolvedView: 'SURVEY_RESOLVED_VIEW',
    tabProcessTabView: 'PROCESS_TAB_VIEW',
    actionProjectColorCodeAdd: 'PROJECT_COLOR_CODE_ADD',
    actionAcknowledgeChangeView: 'PROJECT_ACKNOWLEDGE_CHANGE_VIEW',
    actionAcknowledgeCancelView: 'PROJECT_ACKNOWLEDGE_CANCEL_VIEW',
    actionSyncStatus: 'SYNC_STATUS',
    tabScheduleInfoView: 'SCHEDULE_INFO_VIEW',
    addInstaller: 'ADD_INSTALLER',
    viewInstaller: 'VIEW_INSTALLER',
    viewCalendar: 'VIEW_CALENDAR',
    editInstaller: 'MODIFY_INSTALLER',
    deleteInstaller: 'DELETE_INSTALLER',
    tabSiteInspectionView: 'PROJECT_SITE_INSPECTION',
    tabSiteInspectionAdd: 'ADD_SITE_INSPECTION',
    tabSiteInspectionEdit: 'EDIT_SITE_INSPECTION',
    tabSiteInspectionDelete: 'DELETE_SITE_INSPECTION',
    tabHomeDepotPoView: 'HOME_DEPOT_PO_VIEW',
    tabHomeDepotLeadView: 'HOME_DEPOT_LEAD_VIEW',
    waitingForProductView: 'WAITING_FOR_PRODUCT_VIEW',
    tabExtraColumnView: 'PROJECT_EXTRA_COLUMN',

    viewAdditionalFeeTab: 'PR_INFO_VIEW',

    tabAdditionalFeeView: 'PROJECT_ADDITIONAL_FEE',
    tabAdditionalFeeAdd: 'ADD_ADDITIONAL_FEE',
    tabAdditionalFeeEdit: 'EDIT_ADDITIONAL_FEE',
    tabAdditionalFeeDelete: 'DELETE_ADDITIONAL_FEE',

    tabAdditionalFeeExpensesView: 'VIEW_EXPENSES',
    tabAdditionalFeeExpensesAdd: 'ADD_EXPENSES',
    tabAdditionalFeeExpensesEdit: 'MODIFY_EXPENSES',
    tabAdditionalFeeExpensesDelete: 'DELETE_EXPENSES',

    paymentRequestMenu: 'PAYMENT_REQUEST',
    tabProjectItems: 'PROJECT_ITEMS',
    viewLaborCostFields: 'LABOR_COST_FIELDS',
    viewAllCostFields: 'ALL_COST_FIELDS',
    viewTotalCrewLaborCostEach: 'VIEW_TOTAL_CREW_LABOR_COST_EACH',
    viewTotalCrewLaborCost: 'VIEW_TOTAL_CREW_LABOR_COST',
    tabProjectItemsLaborView: 'VIEW_PROJECT_LABOR',
    tabProjectItemsLaborAdd: 'ADD_PROJECT_LABOR',
    tabProjectItemsLaborModify: 'EDIT_PROJECT_LABOR',
    tabProjectItemsLaborDelete: 'DELETE_PROJECT_LABOR',
    tabProjectItemsMerchandiseView: 'VIEW_PROJECT_MERCHANDISE',
    tabProjectItemsMerchandiseAdd: 'ADD_PROJECT_MERCHANDISE',
    tabProjectItemsMerchandiseModify: 'EDIT_PROJECT_MERCHANDISE',
    tabProjectItemsMerchandiseDelete: 'DELETE_PROJECT_MERCHANDISE',

    tabNotes: 'PROJECT_NOTES',
    tabNotesAdd: 'ADD_NOTES',
    tabNotesView: 'VIEW_NOTES',
    tabTimelineView: 'TIMELINE_VIEW',
    deleteRetailerNotes: 'DELETE_RETAILER_NOTES',
    deleteInstallerNotes: 'DELETE_INSTALLER_NOTES',
    deleteInternalNotes: 'DELETE_INTERNAL_NOTES',
    deleteScheduledNotes: 'DELETE_SCHEDULED_NOTES',
    deleteDeliveryNotes: 'DELIVERY_NOTES_DELETE',
    deleteCxNotes: 'DELETE_CX_NOTES',
    deleteImportantSchedulerNote: 'IMPORTANT_SCHEDULER_NOTE_DELETE',
    deleteImportantInstallerNote: 'IMPORTANT_INSTALLER_NOTE_DELETE',

    addRetailerNotes: 'SEND_RETAILER_NOTE_TO_SOURCE',
    addInstallerNotes: 'ADD_INSTALLER_NOTES',
    addInternalNotes: 'ADD_INTERNAL_NOTES',
    addScheduledNotes: 'ADD_SCHEDULED_NOTES',
    addDeliveryNotes: 'DELIVERY_NOTES_ADD',
    addImportantSchedulerNote: 'IMPORTANT_SCHEDULER_NOTE_ADD',
    addImportantInstallerNote: 'IMPORTANT_INSTALLER_NOTE_ADD',
    viewImportantSchedulerNote: 'IMPORTANT_SCHEDULER_NOTE_VIEW',
    viewImportantInstallerNote: 'IMPORTANT_INSTALLER_NOTE_VIEW',

    tabRelatedPOs: 'PROJECT_RELATED_PO',
    tabDocsView: 'PROJECT_DOCS',
    tabDocs: 'VIEW_DOCS',
    tabDocsAddProjectDocs: 'ADD_PROJECT_DOCS',
    tabDocsCreateRestrictedCopy: 'CREATE_RESTRICTED_COPY_DOCUMENT',
    tabDocsDownloadProjectDocs: 'DOWNLOAD_PROJECT_DOCS',
    tabDocsViewRelated: 'VIEW_RELATED_PROJ_DOCS',
    tabDocsDownloadRelated: 'DOWNLOAD_RELATED_PROJ_DOCS',
    tabPhotosView: 'PROJECT_PHOTOS',
    tabPhotosAdd: 'ADD_PROJECT_PHOTOS',
    tabPhotosDownload: 'DOWNLOAD_PHOTOS',
    relatedMeasurementPhotos: 'RELATED_MEASUREMENT_PHOTOS',
    tabEPALead: 'PROJECT_EPA_LEAD',

    tabPermitting: 'PROJECT_PERMITTING',
    tabPermittingAdd: 'ADD_PERMIT',
    tabPermittingDelete: 'DELETE_PERMIT',
    tabPermittingModify: 'EDIT_PERMITTING',

    tabMerchandiseReturn: 'VIEW_MERCHANDISE_RETURN',
    tabMerchandiseReturnAdd: 'ADD_MERCHANDISE_RETURN',

    tabBilling: 'PROJECT_BILLING',
    tabBillingAdd: 'ADD_PAYMENT',
    tabBillingDelete: 'PROJECT_BILLING_DELETE',
    tabBillingModify: 'PROJECT_BILLING_EDIT',

    tabTimeManagement: 'PROJECT_TIME_MGMT',
    tabActivities: 'PROJECT_ACTIVITIES',
    tabSMS: 'PROJECT_SMS',
    tabProjectSupportView: 'PROJECT_SUPPORT',
    tabProjectSupportAdd: 'ADD_SUPPORT',
    tabProjectSupportEdit: 'EDIT_SUPPORT',
    tabProjectSupportDelete: 'DELETE_SUPPORT',
    tabIssuesView: 'PROJECT_ISSUES',
    tabIssuesAdd: 'ADD_ISSUE',
    tabIssuesEdit: 'EDIT_ISSUE',
    tabIssuesDelete: 'DELETE_ISSUE',
    tabAudit: 'PROJECT_AUDIT',
    tabEmail: 'VIEW_EMAIL',
    tabEmailAdd: 'ADD_EMAIL',
    actionContractReset: 'CONTRACT_RESET_VIEW',
    actionSendScheduleView: 'SEND_SCHEDULE_VIEW',
    actionSendCompleteView: 'SEND_COMPLETE_VIEW',
    editDocs: 'EDIT_DOCS',
    actionDeliveryComplete: 'DELIVERY_COMPLETE_VIEW',
    scheduleNowBtn: 'SCHEDULE_NOW_VIEW',
    sendCxScheduleLinkView: 'SEND_CX_SCHEDULE_LINK',
    customerIssue: 'CUSTOMER_ISSUES_VIEW',

    yearBuiltModify: 'YEAR_BUILT_EDIT',
    actionBillsTableView: 'BILLS_TABLE_VIEW',
    actionBillsTableEdit: 'BILLS_TABLE_EDIT',
    actionInvoiceTableView: 'INVOICE_TABLE_VIEW',
    actionInvoiceTableEdit: 'INVOICE_TABLE_EDIT',
    actionViewPaymentRequest: 'VIEW_PAYMENT_REQUEST',

    revenueOverride: 'REVENUE_OVERRIDE',
    tabImeEstimate: 'IME_ESTIMATE_VIEW',

    docDigitalDetails: 'DOCUMENT_DIGITAL_DETAILS',
  },
  projectItems: {
    laborCostFields: 'LABOR_COST_FIELDS',
    allCostFields: 'ALL_COST_FIELDS',
    addAllCostFields: 'ADD_ALL_COST_FIELDS',
    editAllCostFields: 'EDIT_ALL_COST_FIELDS',
    viewAllMerchandiseCost: 'VIEW_ALL_MERCHANDISE_COST',
    addAllMerchandiseCost: 'ADD_ALL_MERCHANDISE_COST',
    editAllMerchandiseCost: 'EDIT_ALL_MERCHANDISE_COST',
    viewProjectLevelCostField: 'VIEW_PROJECT_LEVEL_COST_FIELDS',
    editLaborProfileItems: 'EDIT_LABOR_PROFILE_ITEMS',
    technicianVisibility: 'TECHNICIAN_VISIBILITY',
    financeApproval: 'LABOR_ITEM_FINANCE_APPROVAL',
    editFinanceApproval: 'LABOR_ITEM_FINANCE_APPROVAL_MODIFY',
    paidApproval: 'LABOR_ITEM_PAID_APPROVAL',
    editPaidApproval: 'LABOR_ITEM_PAID_APPROVAL_MODIFY',
    technicianFinanceApproval: 'LABOR_ITEM_TECHNICIAN_FINANCE_APPROVAL',
    editTechnicianFinanceApproval:
      'LABOR_ITEM_TECHNICIAN_FINANCE_APPROVAL_MODIFY',
    technicianPaidApproval: 'LABOR_ITEM_TECHNICIAN_PAID_APPROVAL',
    editTechnicianPaidApproval: 'LABOR_ITEM_TECHNICIAN_PAID_APPROVAL_MODIFY',
    viewProductItemStatus: 'VIEW_PRODUCT_ITEM_STATUS',
    addProductItemStatus: 'ADD_PRODUCT_ITEM_STATUS',
    editProductItemStatus: 'EDIT_PRODUCT_ITEM_STATUS',
    userAssignedLaborItems: 'USER_ASSIGNED_LABOR_ITEMS',
    cloneItem: 'VIEW_CLONE',
    productTechnicianVisibilityControls:
      'PRODUCT_TECHNICIAN_VISIBILITY_CONTROLS',
    assignTechnicianonProductItem: 'ASSIGN_TECHNICIAN_ON_PRODUCT_ITEM',
    userAssignedProductItems: 'USER_ASSIGNED_PRODUCT_ITEMS',
  },
  admin: {
    menu: 'ADMIN_M',
  },
  laborProfiles: {
    menu: 'LABOR_PROFILES_M',
    laborProfileAdd: 'ADD_LABOR_PROFILE',
    laborProfileEdit: 'EDIT_LABOR_PROFILE',
    laborProfileDelete: 'DELETE_LABOR_PROFILE',
    laborProfileCopy: 'ADD_LABOR_PROFILE', //'COPY_LABOR_PROFILE',
  },
  userManagement: {
    menu: 'USER_MGMT_M',
    userManagementAdd: 'ADD_USER',
    userManagementEdit: 'EDIT_USER',
    userManagementManageRolesView: 'MANAGE_ROLE',
    userManagementManageRolesAdd: 'ADD_ROLE',
    userManagementManageRolesEdit: 'EDIT_ROLE',
    userManagementManageRolesCopy: 'ADD_ROLE', //'COPY_ROLE',
    userManagementManageRolesDelete: 'DELETE_ROLE',
    userManagementViewInstaller: 'VIEW_GLOBAL_INSTALLER',
    userManagementModifyInstaller: 'MODIFY_GLOBAL_INSTALLER',
    userManagementCustomFilterView: 'CUSTOM_FILTER_VIEW',
    userManagementCustomFilterRemove: 'CUSTOM_FILTER_REMOVE',
    userManagementCustomFilterAdd: 'CUSTOM_FILTER_ADD',
  },
  stores: {
    menu: 'STORE_M',
    storesAdd: 'ADD_STORE',
    storesEdit: 'EDIT_STORE',
  },
  dashboardManagement: {
    menu: 'DASHBOARD_MGMT_M',
    createDashboard: 'CREATE_DASHBOARD',
    editDashboard: 'EDIT_DASHBOARD',
    deleteDashboard: 'DELETE_DASHBOARD',
    copyDashboard: 'CREATE_DASHBOARD', //'COPY_DASHBOARD',
    applyFilter: 'DASHBOARD_FILTER_MODIFY',
    clearFilter: 'DASHBOARD_FILTER_CLEAR',
  },
  widgetManagement: {
    menu: 'DASHBOARD_WIDGET_TEMPLATE',
    createWidget: 'DASHBOARD_WIDGET_TEMPLATE_ADD',
    editWidget: 'DASHBOARD_WIDGET_TEMPLATE_EDIT',
    deleteWidget: 'DASHBOARD_WIDGET_TEMPLATE_DELETE',
  },
  documentCenter: {
    menu: 'DOC_CENTER_M',
    showToCustomer: 'VIEW_DOC_SHOW_CUSTOMER',
    addDocTemplate: 'ADD_TEMPLATE',
    editDocTemplate: 'EDIT_TEMPLATE',
    copyDocTemplate: 'ADD_TEMPLATE', //'COPY_TEMPLATE',
    requireSignature: 'VIEW_REQUIRE_SIGNATURE_ON_CX_PORTAL',
    autoCreateDoc: 'VIEW_AUTO_CREATE_PROJECT_DOCUMENT',
    reviewDoc: 'NEEDS_REVIEW_DOCS',
    sendToSourceDoc: 'SEND_TO_SOURCE_DOCS',
    completeDoc: 'COMPLETE_DOCS',
    reviewPhoto: 'NEEDS_REVIEW_PHOTOS',
    sendToSourcePhoto: 'SEND_TO_SOURCE_PHOTOS',
    completePhoto: 'COMPLETE_PHOTOS',
    deleteDoc: 'DELETE_PROJECT_DOCS',
    deletePhoto: 'DELETE_PROJECT_PHOTOS',
    viewDocCategory: 'VIEW_DOCUMENT_CATEGORY',
    addDocCategory: 'ADD_DOCUMENT_CATEGORY',
    editDocCategory: 'EDIT_DOCUMENT_CATEGORY',
    viewPhotoCategory: 'VIEW_PHOTO_CATEGORY',
    addPhotoCategory: 'ADD_PHOTOS_CATEGORY',
    editPhotoCategory: 'EDIT_PHOTOS_CATEGORY',
    viewDocumentReview: 'VIEW_DOCUMENT_REVIEW',
    viewPhotoReview: 'VIEW_PHOTO_REVIEW',
  },
  ruleEngineLog: {
    menu: 'RULE_ENGINE_LOGS_VIEW',
  },
  personnel: {
    menu: 'PERSONNEL_M',
  },
  availabilityUpdates: {
    menu: 'AVAILABILITY_UPDATE_M',
    addAvailabilityUpdates: 'ADD_AVAILABILITY',
    editAvailabilityUpdates: 'EDIT_AVAILABILITY',
    availabilityUpdatesApproval: 'AVAILABILITY_UPDATE_APPROVAL',
    viewAvailabilityUpdateCancel: 'VIEW_AVAILABILITY_UPDATE_CANCEL',
    viewAvailabilityUpdateWithdraw: 'VIEW_AVAILABILITY_UPDATE_WITHDRAW',
    availabilityUpdateForAllUser: 'AVAILABILITY_UPDATE_ALL_VIEW',
  },
  globalSearch: {
    menu: 'GLOBAL_SEARCH',
    redirectHandler: 'GLOBAL_SEARCH_REDIRECT_NEW_TAB',
  },
  pullDownMenu: {
    view: 'VIEW_PULL_DOWN_MENU',
    installerNotes: 'PULL_DOWN_VISIBILITY_INSTALLER_NOTES',
    storeNotes: 'PULL_DOWN_VISIBILITY_STORE_NOTES',
    email: 'PULL_DOWN_VISIBILITY_EMAIL',
    sms: 'PULL_DOWN_VISIBILITY_SMS',
    customerChats: 'PULL_DOWN_VISIBILITY_CUSTOMER_CHATS',
    customerNotes: 'PULL_DOWN_VISIBILITY_CXSCHEDULING_NOTES',
    crmClient: 'CRM_COMMUNICATION_CLIENT',
    crmLeads: 'CRM_COMMUNICATION_LEADS',
    crmQuotes: 'CRM_COMMUNICATION_QUOTES',
    crmInvoices: 'CRM_COMMUNICATION_INVOICES',
    crmPayments: 'CRM_COMMUNICATION_PAYMENT',
  },
  crm: {
    addClientSource: 'ADD_CLIENT_SOURCE',
    editClientSource: 'MODIFY_CLIENT_SOURCE',
    deleteClientSource: 'DELETE_CLIENT_SOURCE',
  },
  opportunity: {
    addType: 'ADD_OPPORTUNITY_TYPE',
    editType: 'MODIFY_OPPORTUNITY_TYPE',
    deleteType: 'DELETE_OPPORTUNITY_TYPE',
    addCategory: 'ADD_OPPORTUNITY_CATEGORY',
    editCategory: 'MODIFY_OPPORTUNITY_CATEGORY',
    deleteCategory: 'DELETE_OPPORTUNITY_CATEGORY',
    addStatus: 'ADD_OPPORTUNITY_STATUS',
    editStatus: 'MODIFY_OPPORTUNITY_STATUS',
    deleteStatus: 'DELETE_OPPORTUNITY_STATUS',
    addSource: 'ADD_OPPORTUNITY_SOURCE',
    editSource: 'MODIFY_OPPORTUNITY_SOURCE',
    deleteSource: 'DELETE_OPPORTUNITY_SOURCE',
  },
  sms: {
    viewSMS: 'VIEW_SMS',
  },
  mobilePermissions: {
    retailerNoteVisibility: 'SEND_RETAILER_NOTE_TO_SOURCE',
  },
  payroll: {
    menu: 'VIEW_PAYROLL',
    review: 'VIEW_REVIEW',
    approve: 'VIEW_APPROVE',
    exclude: 'VIEW_EXCLUDE',
  },
  invoicePayments: {
    menu: 'VIEW_INVOICE_PAYMENTS',
  },
  questionnaire: {
    view: 'QUESTIONNAIRE_VIEW',
    edit: 'QUESTIONNAIRE_EDIT',
    projectViewAnswer: 'PROJECT_QUESTIONNAIRE_ANSWER_VIEW',
    projectDeleteAnswer: 'PROJECT_QUESTIONNAIRE_ANSWER_DELETE',
  },
  addGlobalInstaller: 'ADD_GLOBAL_INSTALLER',
  autoScheduling: {
    hideBanner: 'EDIT_AUTO_SCHEDULING_BANNER',
    viewBanner: 'VIEW_AUTO_SCHEDULING_BANNER',
  },
  chargeback: {
    add: 'ADD_APPROVE_CHARGEBACK',
    edit: 'EDIT_APPROVE_CHARGEBACK',
    reason: {
      add: 'CHARGEBACK_REASON_ADD',
    },
  },
  notes_to_customer: {
    view: 'NOTE_TO_CUSTOMER_VIEW',
    add: 'NOTE_TO_CUSTOMER_ADD',
    update: 'NOTE_TO_CUSTOMER_UPDATE',
    delete: 'NOTE_TO_CUSTOMER_DELETE',
  },
  customer_notes: {
    view: 'CUSTOMER_NOTES_VIEW',
    update: 'CUSTOMER_NOTES_UPDATE',
  },
  important_scheduler_note: {
    view: 'IMPORTANT_SCHEDULER_NOTE_VIEW',
    add: 'IMPORTANT_SCHEDULER_NOTE_ADD',
    delete: 'IMPORTANT_SCHEDULER_NOTE_DELETE',
    update: 'IMPORTANT_SCHEDULER_NOTE_MODIFY',
  },
  important_installer_note: {
    view: 'IMPORTANT_INSTALLER_NOTE_VIEW',
    add: 'IMPORTANT_INSTALLER_NOTE_ADD',
    delete: 'IMPORTANT_INSTALLER_NOTE_DELETE',
    update: 'IMPORTANT_INSTALLER_NOTE_MODIFY',
  },
  bulkUpdate: {
    view: 'MULTI_RECORD_EDIT_VIEW',
  },
  template: {
    view: 'TEMPLATE_VIEW',
  },
  quote: {
    view: 'QUOTE_TEMPLATE_VIEW',
    add: 'QUOTE_TEMPLATE_ADD',
    edit: 'QUOTE_TEMPLATE_UPDATE',
    delete: 'QUOTE_TEMPLATE_DELETE',
  },
  email: {
    view: 'EMAIL_TEMPLATE_VIEW',
    add: 'EMAIL_TEMPLATE_ADD',
    edit: 'EMAIL_TEMPLATE_UPDATE',
    delete: 'EMAIL_TEMPLATE_DELETE',
  },
  templateConfiguration: {
    view: 'VIEW_ACTION_BTN_TEMP_CONFIG',
    add: 'ADD_ACTION_BTN_TEMP_CONFIG',
    edit: 'MODIFY_ACTION_BTN_TEMP_CONFIG',
    delete: 'DELETE_ACTION_BTN_TEMP_CONFIG',
  },
  purchaseOrdertab: {
    view: 'PURCHASE_ORDER_VIEW',
    edit: 'PURCHASE_ORDER_UPDATE',
    delete: 'PURCHASE_ORDER_DELETE',
  },
  generalPurchaseOrder: {
    view: 'GENERAL_PURCHASE_ORDER_VIEW',
    add: 'GENERAL_PURCHASE_ORDER_ADD',
    edit: 'GENERAL_PURCHASE_ORDER_UPDATE',
    delete: 'GENERAL_PURCHASE_ORDER_DELETE',
  },
  map: {
    view: 'MAP_VIEW',
    unassigned_map: 'UNASSIGNED_PROJECT_MAP',
  },
  closeProjectTask: {
    edit: 'CLOSE_TASKS_MODIFY',
  },
  vendorManagement: {
    view: 'VENDOR_MANAGEMENT_VIEW',
    add: 'VENDOR_MANAGEMENT_ADD',
    edit: 'VENDOR_MANAGEMENT_UPDATE',
  },
  companyManagement: {
    view: 'COMPANY_MANAGEMENT_VIEW',
    add: 'COMPANY_MANAGEMENT_ADD',
    edit: 'COMPANY_MANAGEMENT_UPDATE',
    delete: 'COMPANY_MANAGEMENT_DELETE',
  },
  municipalityRegistration: {
    menu: 'VIEW_MUNICIPALITY_REGISTRATION',
    add: 'ADD_MUNICIPALITY_REGISTRATION',
    edit: 'MODIFY_MUNICIPALITY_REGISTRATION',
  },
  generatePOButton: {
    view: 'GENERATE_PO_BUTTON_VIEW',
  },
  userActivityLogs: {
    view: 'USER_ACTIVITY',
  },
  emailEventDashboard: {
    view: 'EMAIL_EVENTS_TRACKING',
  },
  profitLoss: {
    view: 'PROJECT_COST_VIEW',
  },
  acitvityWorkFlow: {
    schedulingCoordinator: 'SCHEDULING_COORDINATOR',
    fieldServiceManager: 'FIELD_SERVICE_MANAGER',
    projectCoordinator: 'PROJECT_COORDINATOR',
    productionCoordinator: 'PRODUCTION_COORDINATOR',
    measureTechnicianSupervisor: 'MEASURE_TECHNICIAN_SUPERVISOR',
    adminActivityAssigment: 'ADMIN_ACTIVITY_ASSIGNMENT',
    operationsAcitvityAssigment: 'OPERATIONS_ACTIVITY_ASSIGNMENT',
  },
  recurringEvent: {
    view: 'RECURRING_EVENTS_VIEW',
    edit: 'RECURRING_EVENTS_MODIFY',
    delete: 'RECURRING_EVENTS_DELETE',
  },
};

export default permissions;
